import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { PipelineStagesHttpService } from './pipeline-stages-http.service';
import { PipelineStagesActions } from './pipeline-stages.store';

@Injectable({
  providedIn: 'root',
})
export class PipelineStagesEffects {
  public effects = createEffectFactory(PipelineStagesActions, this.actions$);

  public fetch$ = this.effects(PipelineStagesActions.fetchOne, ({ payload: { id, params } }) =>
    this.http.fetchOne$(id, params).pipe(
      map(response => ({
        data: {
          stages: response.stages,
          id: response.id,
        },
      })),
    ),
  );

  public updateStagePlacements$ = this.effects(
    PipelineStagesActions.updateStagePlacements,
    ({ payload: { offerSlug, params } }) =>
      this.http.fetchStagePlacements$(offerSlug, params).pipe(
        map(placements =>
          PipelineStagesActions.updateStagePlacementsSuccess({
            payload: { placements, offerSlug, stageId: params.stage_id },
          }),
        ),
        catchError((error: HttpErrorResponse) =>
          of(
            PipelineStagesActions.updateStagePlacementsFailed({
              payload: { error, offerSlug: offerSlug },
            }),
          ),
        ),
      ),
  );

  public updatePlacement$ = this.effects(PipelineStagesActions.updatePlacement, ({ payload }) =>
    this.http.fetchPlacement(payload.offerId, payload.candidateId, payload.params).pipe(
      map(data =>
        PipelineStagesActions.updatePlacementSuccess({
          payload: { data, offerSlug: payload.offerSlug },
        }),
      ),
      catchError((error: HttpErrorResponse) =>
        of(
          PipelineStagesActions.updatePlacementFailed({
            payload: { error, offerSlug: payload.offerSlug },
          }),
        ),
      ),
    ),
  );

  constructor(
    private http: PipelineStagesHttpService,
    private actions$: Actions,
  ) {}
}
